import * as React from "react"
import LeadForm from "../dto/LeadForm";
import ContactFormGroup from "../../../contacts/form/component/ContactFormGroup";
import AddressFormGroup from "../../../address/form/component/AddressFormGroup";
import LeadCategoryFormGroup from "../LeadCategoryFormGroup";
import SectionView from "../../../layout/section/SectionView";
import {none, Option, option} from "ts-option";
import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import SectionSeparator from "../../../layout/section/SectionSeparator";
import LeadAcquistionFormGroup from "../LeadAcquistionFormGroup";
import SelectUsersFormGroup from "../SelectUsersFormGroup";
import LeadTypeGroup from "../LeadTypeGroup";
import Appointment from "../../../../model/appointment/Appointment";
import AppointmentForm from "../../../appointment/AppointmentForm";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import MentionFormGroup from "../../../ui/form/MentionFormGroup";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import User from "../../../../model/user/User";
import AgentSelectorFormGroup from "../AgentSelectorFormGroup";

interface ComponentProps {
	/**
	 * Array of appointments to create
	 */
	appointmentsToCreate: Option<Appointment[]>;
	/**
	 * On appointments change callback
	 * @param {Option<Appointment[]>} appointments
	 */
	onAppointmentsChange: (appointments: Option<Appointment[]>) => void;
}

type Props = ComponentProps & FormBodyProps<LeadForm>
/**
 * Lead form body.
 */
export default class AddLeadFormBody extends React.Component<Props> {
	constructor(props: Props) {
		super(props);

		this.onAppointmentCreate = this.onAppointmentCreate.bind(this);
		this.onAppointmentUpdate = this.onAppointmentUpdate.bind(this);
	}

	render() {
		return (
			<React.Fragment>
				<SectionView>
					<Row customClass={"a-mb-20"}>
						<Col xl={6} lg={6}>
							<AddressFormGroup label="Site"
											  field={this.props.form.address}
											  onChange={field => {
												  field.getOptionalValue().isDefined ? this.props.onFieldCompleted(field) :
													  this.props.onFieldChange(field)
											  }}
											  form={this.props.form}
											  onFocusChange={this.props.onFocusChange}/>
						</Col>
						<Col xl={6} lg={6}>
							<ContactFormGroup label="Primary contact"
											  field={this.props.form.principalContactId}
											  onChange={this.props.onFieldCompleted}
											  form={this.props.form}
											  onFocusChange={this.props.onFocusChange}/>
						</Col>
					</Row>
					<Row>
						<Col xl={6} lg={6}>
							<LeadCategoryFormGroup label="Reason for contact"
												   field={this.props.form.categories}
												   onChange={this.props.onFieldChange}/>
						</Col>
						<Col xl={6} lg={6}>
							<MentionFormGroup label="Description"
											  field={this.props.form.extendedDescription}
											  onChange={this.props.onFieldChange}
											  form={this.props.form}/>
						</Col>
					</Row>
					<SectionSeparator style={{margin: "30px -25px"}}/>
					<Row>
						<Col xl={6} lg={6}>
							<LeadAcquistionFormGroup label="How did the Prospect hear about us?"
													 placeholder="How did the Prospect hear about us?"
													 field={this.props.form.acquisitionChannelId}
													 onChange={this.props.onFieldChange}/>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className={"marketing-tracking"}>
								<label>
									Inbound Marketing &amp; Tracking
								</label>
								<Row>
									<Col lg={6} xl={6}>
										<InputFormGroup label="Campaign"
														field={this.props.form.campaign}
														focus={this.props.form.hasFocus(this.props.form.campaign)}
														onChange={this.props.onFieldChange}/>
									</Col>
									<Col lg={6} xl={6}>
										<InputFormGroup label="Source"
														field={this.props.form.source}
														focus={this.props.form.hasFocus(this.props.form.source)}
														onChange={this.props.onFieldChange}/>
									</Col>
								</Row>
								<Row>
									<Col lg={6} xl={6}>
										<InputFormGroup label="Ad Group"
														field={this.props.form.adGroup}
														focus={this.props.form.hasFocus(this.props.form.adGroup)}
														onChange={this.props.onFieldChange}/>
									</Col>
									<Col lg={6} xl={6}>
										<InputFormGroup label="Landing Page"
														field={this.props.form.landingPage}
														focus={this.props.form.hasFocus(this.props.form.landingPage)}
														onChange={this.props.onFieldChange}/>
									</Col>
								</Row>
								<Row>
									<Col lg={6} xl={6}>
										<InputFormGroup label="URL"
														field={this.props.form.url}
														focus={this.props.form.hasFocus(this.props.form.url)}
														onChange={this.props.onFieldChange}/>
									</Col>
								</Row>
							</div>
						</Col>
					</Row>
					<SectionSeparator style={{margin: "30px -25px"}}/>
					<Row>
						<Col xl={6} lg={6}>
							<LeadTypeGroup label={"Type of lead"}
										   field={this.props.form.leadType}
										   onChange={this.props.onFieldChange}/>
						</Col>
						<Col xl={6} lg={6}>
							<SelectUsersFormGroup field={this.props.form.watchers}
												  onChange={this.props.onFieldChange}
												  label="Watchers"
												  placeholder="Watchers"
												  filterFunction={this.filterWatchers}/>
						</Col>
					</Row>
					<SectionSeparator style={{margin: "30px -25px"}}/>
					<Row>
						<Col xl={6} lg={6}>
							<AgentSelectorFormGroup label={"Lead Agent"}
													onChange={this.props.onFieldChange}
													field={this.props.form.agentId}/>
						</Col>
					</Row>
					<SectionSeparator style={{margin: "30px -25px"}}/>
					<Row>
						<Col>
							<AppointmentForm leadId={none}
											 onAppointmentCreate={this.onAppointmentCreate}
											 onAppointmentUpdate={this.onAppointmentUpdate}
											 appointmentsToCreate={this.props.appointmentsToCreate}
											 addAppointmentPossible={true}
											 leadFormContactId={this.props.form.principalContactId.getOptionalValue()}/>
						</Col>
					</Row>
				</SectionView>
			</React.Fragment>
		);
	}

	filterWatchers = (user: User) => user.canBeWatcher();

	onAppointmentCreate(appointment: Appointment) {
		this.props.onAppointmentsChange(
			option(this.props.appointmentsToCreate.getOrElse([]).concat(appointment).sort((a, b) => a.dateTime.diff(b.dateTime))))
	}

	onAppointmentUpdate(appointment: Appointment) {
		this.props.onAppointmentsChange(option(this.props.appointmentsToCreate.map(
			tab => tab.map(item => item.id == appointment.id ? appointment : item).sort(
				(a, b) => a.dateTime.diff(b.dateTime))).orNull));
	}
}